import { Component, computed, effect, inject, input, untracked } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AvatarService } from '@shared/services/avatar.service';

/**
 * Avatar de usuario: foto subida si existe; si no, el generado por DiceBear
 * (initials) con el nombre como seed. Mientras carga muestra el DiceBear.
 */
@Component({
  selector: 'app-user-avatar',
  standalone: true,
  imports: [CommonModule],
  template: `
    <img class="avatar"
         [src]="url()"
         [alt]="name()"
         [style.width.px]="size()"
         [style.height.px]="size()">
  `,
  styles: [`
    :host { display: inline-flex; line-height: 0; }
    .avatar {
      border-radius: 50%;
      object-fit: cover;
      background: var(--gdp-surface, #f6f7fb);
    }
  `]
})
export class UserAvatarComponent {
  accountId = input.required<number>();
  name = input.required<string>();
  size = input<number>(32);

  private readonly avatarService = inject(AvatarService);

  constructor() {
    // La petición HTTP se lanza fuera del grafo reactivo (evita NG0600)
    effect(() => {
      const accountId = this.accountId();
      const name = this.name();
      untracked(() => this.avatarService.ensure(accountId, name));
    });
  }

  readonly url = computed(() =>
    this.avatarService.urlFor(this.accountId())()
      ?? this.avatarService.dicebearFor(this.name())
  );
}
